import { observer } from 'mobx-react-lite';
import { animationStore } from '../../../../store/animationStore';
import { doBetStore } from '../../../../store';

export const GameClosBtn = observer(({ gameTypeId }) => {
  const { setToggleGameClosed, isGameClosedByGameType } = animationStore;
  const { doBetSectionsData } = doBetStore;
  const { isBetAccepted } = doBetSectionsData[gameTypeId];
  const allGameOpenCloseList = Object.values(isGameClosedByGameType);
  const isClosedGameLimit =
    allGameOpenCloseList.filter((item) => item).length === allGameOpenCloseList.length - 1;
  const hideLastGameInactiveIcon = isClosedGameLimit && !isGameClosedByGameType[gameTypeId];

  return (
    !hideLastGameInactiveIcon &&
    !isBetAccepted && (
      <div
        className='pascal-game-col-close'
        onClick={() => setToggleGameClosed(!isGameClosedByGameType[gameTypeId], gameTypeId)}
      />
    )
  );
});
